import { useInfiniteQuery } from '@tanstack/react-query';
import { StationVisitsFilter } from '@gettactic/api';
import { api } from '@/lib/api/api';

export function useVisits(filters: StationVisitsFilter) {
  if (!filters.limit) {
    filters.limit = 100;
  }
  const {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    status
  } = useInfiniteQuery(
    ['stations.stationVisits', filters],
    async ({ pageParam: cursor }) => {
      if (cursor) {
        filters.cursor = cursor;
      }
      const res = await api.client.stations.stationVisits(filters);
      return res.result;
    },
    {
      getNextPageParam: (lastPage) =>
        (lastPage?.elements.length ?? 0) < (filters.limit ?? 0)
          ? undefined
          : lastPage?.cursor ?? undefined
    }
  );

  return {
    data,
    error,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isFetchingNextPage,
    status
  };
}
